// extracted by mini-css-extract-plugin
module.exports = {"stack":"page_stack__WYaUZ","root":"page_root__iGohI","text":"page_text__0fk5q"};